"use client";

import * as React from "react";

import { useTranslation } from "react-i18next";

import Input from "./input";

import type { InputProps } from "./input";

export default function PasswordInput(props: Omit<InputProps, "type">) {
  const [visible, setVisible] = React.useState(false);
  const { t } = useTranslation("common");
  return (
    <Input
      {...props}
      type={visible ? "text" : "password"}
      endAdornment={
        <button
          type="button"
          tabIndex={-1}
          aria-pressed={visible}
          aria-label={visible ? t("password.hide") : t("password.show")}
          onClick={() => setVisible((v) => !v)}
          className="text-garnet/80 hover:text-garnet inline-flex items-center"
        >
          <img
            src="/hide-eye.svg"
            alt=""
            className="h-[15px] w-[21px]"
            height={15}
            width={21}
          />
        </button>
      }
    />
  );
}
